module.exports = __webpack_public_path__ + "media/images/gallery/constellations/cygnus/cyg_vis-b4b441777be0d42a8f3df298a13bc025.jpg";